import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Category', prop: 'resource_category_id', references: 'admin/resource_categories', referenceProp: 'name' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' }
]

const filters = [
  { name: 'Filter by name', prop: 'filters.name_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [{ column: 'name', direction: 'asc' }]
}

const Resources = (props) => (
  <List
    title='Resources'
    apiPath='admin/resources'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Resources
